module.exports = __webpack_public_path__ + "img/signature.d783cbea.png";